<template>
  <van-popup
    v-model="showPoster"
    closeable
    :transition-appear="true"
    transition="fade"
    duration="1"
    close-icon="close"
  >
    <div class="poster">
      <div class="swiper-container">
        <div
          v-for="(item, index) in imgList"
          :key="index"
          ref="faultTree"
          class="swiper-slide"
        >
          <!-- 海报图片，二维码附到海报上，所以绑定到该海报上 -->
          <img class="bg" :src="item.img" alt="" @load="imgOnload" />
          <!-- 二维码图片 -->
          <div class="qr-code-content">
            <div class="qr-code-text">
              <p>长按识别二维码</p>
              <p>参与答题活动</p>
            </div>
            <img class="qr-code-img" :src="activityConfig.qrcodeFilePath" alt="" />
          </div>
          <!-- 长按海报后会生成base64图片地址（包含海报+二维码）用于去分享、收藏操作 -->
          <img
            v-if="item.screenshotUrl"
            class="screenshot"
            :src="item.screenshotUrl"
            alt=""
          />
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Swiper from "swiper";
import html2canvas from "html2canvas";
import { Toast, Popup } from "vant";
export default {
  components: {
    [Popup.name]: Popup,
  },
  props: {
    formCustom: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      showPoster: false,
      activityConfig: {},
      imgList: [
        {
          img: "",
          screenshotUrl: "",
        },
      ],
      currentIndex: 0,
    };
  },
  computed: {},
  created() {
    this.showPoster = true;
    document.title = "趣味表单海报分享";
    this.activityConfig =
      this.formCustom.activityConfig ||
      JSON.parse(sessionStorage.getItem("activityConfig")).activityConfig;
    console.log(this.activityConfig, "海报分享数据");
    // 海报展示
    setTimeout(() => {
      if (this.activityConfig.sharePosterImgUrl) {
        this.imgList[0].img = this.activityConfig.sharePosterImgUrl;
      }
    }, 300);
    // 设置提示延迟防止进入海报页面马上分享，造成图片未合成一起会分享单个图片
    Toast.loading({
      message: "海报生成中...",
      forbidClick: true,
      duration: 0, // 默认值为2秒，设置为0，表示不会消失，需手动清除
    });
  },
  mounted() {
    new Swiper(".swiper-container", {
      pagination: {
        el: ".swiper-pagination",
      },
      on: {
        slideChangeTransitionStart: function (swiper) {
          this.currentIndex = this.activeIndex;
        },
      },
    });
  },
  methods: {
    // 截图区域
    imgOnload() {
      const ref = this.$refs.faultTree;
      ref.forEach(async (item, index) => {
        await this.html2canvas(item, index);
      });
    },
    // 合成海报+二维码地址
    html2canvas(item, index) {
      return new Promise((resolve) => {
        html2canvas(item, {
          useCORS: true,
        })
          .then((canvas) => {
            const dataURL = canvas.toDataURL("image/png");
            this.imgList[index].screenshotUrl = dataURL;
            Toast.clear();
            resolve(dataURL);
          })
          .catch(() => {
            Toast.clear();
          });
      });
    },
  },
};
</script>

<style>
.poster {
  height: auto;
  background: none;
  background-size: 100% 100%;
}

.poster .swiper-container {
  width: 300px;
}
.poster .swiper-slide {
  background-position: center;
  background-size: cover;
  height: 488px;
  position: relative;
  width: 100%;
}
.poster .swiper-slide .bg {
  width: 100%;
  height: 488px;
}
.poster .qr-code-content {
  position: absolute;
  bottom: 15px;
  right: 5px;
  text-align: center;
}
.poster .qr-code-text {
  margin-right: 80px;
}
.poster .qr-code-img {
  width: 58px;
  height: 58px;
  background-color: #fff;
  position: absolute;
  bottom: 0px;
  right: 12px;
}
.poster .screenshot {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 480px;
  opacity: 0;
  z-index: 99999;
}
.poster .qr-code-content p {
  font-size: 14px;
  color: #1a1a1a;
  letter-spacing: 0;
  text-align: right;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/interest-form/components/share-poster.vue